module.exports = __webpack_public_path__ + "static/media/knowledgehut.22c8585c.png";